export const RESPONSIVE_BREAKPOINTS = {
    sm: 500,
    md: 768,
    lg: 1024,
    xl: 1280,
    xxl: 1440,
} as const;

export type ResponsiveBreakpointName = keyof typeof RESPONSIVE_BREAKPOINTS;
